import React from 'react';
import AppDialog from '../AppDialog/AppDialog';
import { t } from '../../utils/i18n';
import { REGISTER_PARTNER_CELEB_ACTION } from '../../utils/partnerCelebActions';

/**
 * Confirm + result alert dialogs for partner celeb register/unregister flow.
 */
export default function PartnerCelebDialog({ dialog, onConfirm, onCancel, loading }) {
  if (!dialog) return null;

  if (dialog.kind === 'confirm') {
    const isRegister = dialog.action === REGISTER_PARTNER_CELEB_ACTION;
    return (
      <AppDialog
        open
        mode="confirm"
        variant={isRegister ? 'success' : 'danger'}
        title={
          isRegister
            ? t('user.partnerCeleb.dialog.titleRegister')
            : t('user.partnerCeleb.dialog.titleUnregister')
        }
        message={dialog.message}
        confirmLabel={
          isRegister
            ? t('user.partnerCeleb.register.button')
            : t('user.partnerCeleb.unregister.button')
        }
        onConfirm={onConfirm}
        onCancel={onCancel}
        loading={loading}
      />
    );
  }

  if (dialog.kind === 'alert') {
    const isError = dialog.variant === 'error';
    return (
      <AppDialog
        open
        mode="alert"
        variant={isError ? 'danger' : 'success'}
        title={
          isError ? t('user.partnerCeleb.dialog.titleError') : t('user.partnerCeleb.dialog.titleSuccess')
        }
        message={dialog.message}
        onCancel={onCancel}
      />
    );
  }

  return null;
}
